// extracted by mini-css-extract-plugin
export default {"AdminItemDiv":"AdminListItemSkeleton_AdminItemDiv__YtfEV","AdminItemDetails":"AdminListItemSkeleton_AdminItemDetails__sTtsy"};